import { getAppContext, getRefreshToken } from '@gef-ui/redux-common/selectors/appContext';
import assoc from "ramda/es/assoc";
import compose from "ramda/es/compose";
import identity from "ramda/es/identity";
import mergeRight from "ramda/es/mergeRight";
import objOf from "ramda/es/objOf";
import pickAll from "ramda/es/pickAll";
import ramdaUseWith from "ramda/es/useWith";
import values from "ramda/es/values";
import zipObj from "ramda/es/zipObj";
import { createSelector } from 'reselect';
import { oauthGrantTypes, oauthTokenTypes } from '../constants';
import { viewCode } from '../utils';
export const getCode = createSelector(getAppContext, viewCode);
export const getMandatoryAuthorizationGrantOAuthProps = createSelector(getAppContext, compose(zipObj([
    'code',
    'client_id',
    'scope',
    'redirect_uri'
]), values, pickAll([
    'code',
    'clientId',
    'scope',
    'redirectUri'
])));
export const getOauthBodyWithAuthorizationGrantType = createSelector(getMandatoryAuthorizationGrantOAuthProps, assoc('grant_type', oauthGrantTypes.AUTHORIZATION));
export const getMandatoryRefreshGrantOAuthProps = createSelector(getAppContext, compose(zipObj([
    'client_id',
    'scope',
    'redirect_uri'
]), values, pickAll([
    'clientId',
    'scope',
    'redirectUri'
])));
export const getOauthRefreshGrantBody = createSelector([
    getRefreshToken,
    getMandatoryRefreshGrantOAuthProps
], ramdaUseWith(mergeRight, [
    objOf(oauthTokenTypes.REFRESH),
    identity
]));
export const getOauthBodyWithRefreshTokenGrantType = createSelector(getOauthRefreshGrantBody, assoc('grant_type', oauthGrantTypes.REFRESH_TOKEN));
